import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';

import Avatar from 'components/common/Avatar';
import IconBox from 'components/icons/IconBox';

const styles = () => ({
  grid: {
    '& + &': {
      marginTop: 8,
    },
  },
  img: {
    width: '100%',
    height: 'auto',
    textAlign: 'center',
  },
  secondaryImage: {
    width: 48,
    height: 48,
    overflow: 'hidden',
    margin: '8px 4px 0 4px',
    '& + &': {
      marginTop: 16,
    },
  },
  secondaryImages: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 -16px',
  },
  imagePreview: {
    display: 'block',
    maxWidth: '100%',
    width: '100%',
    imageRendering: 'crisp-edges',
  },
  avatar: {
    width: 'auto',
    height: 'auto',
  },
  iconBox: {
    width: 100,
    height: 100,
  },
});

const InventoryCreateEditTable = ({
  className,
  Model,
  Vendor,
  Condition,
  classes,
  Image,
  Category,
  Warehouse,
  ...otherProps
}) => {
  let imageSrc;
  let infoGridWidth = 12;
  const imagesLength = Image.length;
  if (imagesLength > 0) {
    imageSrc = process.env.REACT_APP_API_ROOT
      ? `${process.env.REACT_APP_API_ROOT}${Image[0]['File Url']}${Image[0]['File Name']}`
      : `${Image[0]['File Url']}${Image[0]['File Name']}`;
    // infoGridWidth = 10;
    // if (imagesLength > 5) {
    //   infoGridWidth = 7;
    // } else if (imagesLength > 3) {
    //   infoGridWidth = 8;
    // } else if (imagesLength > 1) {
    //   infoGridWidth = 9;
    // }
  }
  return (
    <div className={className}>
      <Grid
        className={classes.grid}
        container
        spacing={16}
      >
        {imageSrc ?
          <Fragment>
            <Grid
              item
              xs={2}
            >
              <img
                className={classes.img}
                src={imageSrc}
                alt={otherProps['Product Name']}
              />
              {Image.length > 1 &&
                <div className={classes.secondaryImages}>
                  {Image.slice(1, 7).map((item) => {
                    let itemPreviewSrc;
                    if (item.type) {
                      itemPreviewSrc = item.preview;
                    } else {
                      itemPreviewSrc = process.env.REACT_APP_API_ROOT
                        ? `${process.env.REACT_APP_API_ROOT}${item['File Url']}${item['File Name']}`
                        : `${item['File Url']}${item['File Name']}`;
                    }
                    return (
                      <div className={classes.secondaryImage} key={itemPreviewSrc}>
                        <img
                          className={classes.imagePreview}
                          src={itemPreviewSrc}
                          alt={otherProps['Product Name']}
                        />
                      </div>
                    );
                  })}
                </div>
              }
            </Grid>
            {/*{Image.length > 1 &&
              <Grid
                item
                xs={1}
              >
                {Image.slice(1, 3).map((item) => {
                  let itemPreviewSrc;
                  if (item.type) {
                    itemPreviewSrc = item.preview;
                  } else {
                    itemPreviewSrc = process.env.REACT_APP_API_ROOT
                      ? `${process.env.REACT_APP_API_ROOT}${item['File Url']}${item['File Name']}`
                      : `${item['File Url']}${item['File Name']}`;
                  }
                  return (
                    <div className={classes.secondaryImage} key={itemPreviewSrc}>
                      <img
                        className={classes.imagePreview}
                        src={itemPreviewSrc}
                        alt={otherProps['Product Name']}
                      />
                    </div>
                  );
                })}
              </Grid>
            }
            {Image.length > 3 &&
              <Grid
                item
                xs={1}
              >
                {Image.slice(3, 5).map((item) => {
                  let itemPreviewSrc;
                  if (item.type) {
                    itemPreviewSrc = item.preview;
                  } else {
                    itemPreviewSrc = process.env.REACT_APP_API_ROOT
                      ? `${process.env.REACT_APP_API_ROOT}${item['File Url']}${item['File Name']}`
                      : `${item['File Url']}${item['File Name']}`;
                  }
                  return (
                    <div className={classes.secondaryImage} key={itemPreviewSrc}>
                      <img
                        className={classes.imagePreview}
                        src={itemPreviewSrc}
                        alt={otherProps['Product Name']}
                      />
                    </div>
                  );
                })}
              </Grid>
            }
            {Image.length > 5 &&
              <Grid
                item
                xs={1}
              >
                {Image.slice(5, 7).map((item) => {
                  let itemPreviewSrc;
                  if (item.type) {
                    itemPreviewSrc = item.preview;
                  } else {
                    itemPreviewSrc = process.env.REACT_APP_API_ROOT
                      ? `${process.env.REACT_APP_API_ROOT}${item['File Url']}${item['File Name']}`
                      : `${item['File Url']}${item['File Name']}`;
                  }
                  return (
                    <div className={classes.secondaryImage} key={itemPreviewSrc}>
                      <img
                        className={classes.imagePreview}
                        src={itemPreviewSrc}
                        alt={otherProps['Product Name']}
                      />
                    </div>
                  );
                })}
              </Grid>
            }*/}
          </Fragment>
        : (
          <Grid
            item
            xs={2}
          >
            <Avatar
              className={classes.avatar}
              src={imageSrc}
              variant="square"
              placeholderImage={(
                <IconBox className={classes.iconBox} />
              )}
            />
          </Grid> 
        )}
        <Grid
          item
          xs={10}
        >
          <Grid
            className={classes.grid}
            container
            spacing={24}
          >
            <Grid
              item
              xs={4}
            >
              <Typography
                variant="caption"
                gutterBottom
              >
                Product Name
              </Typography>
              <Typography>
                {otherProps['Product Name']}
              </Typography>
            </Grid>    
            <Grid
              item
              xs={4}
            >
              <Typography
                variant="caption"
                gutterBottom
              >
                Serial / Model
              </Typography>
              <Typography>
                {Model}
              </Typography>
            </Grid>
            <Grid
              item
              xs={4}
            >
              <Typography
                variant="caption"
                gutterBottom
              >
                Vendor
              </Typography>
              <Typography>
                {Vendor['Vendor Name']}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            className={classes.grid}
            container
            spacing={24}
          >
            <Grid
              item
              xs={4}
            >
              <Typography
                variant="caption"
                gutterBottom
              >
                Category
              </Typography>
              <Typography>
                {Category.Name}
              </Typography>
            </Grid>
            <Grid
              item
              xs={4}
            >
              <Typography
                variant="caption"
                gutterBottom
              >
                Condition
              </Typography>
              <Typography>
                {Condition.Name}
              </Typography>
            </Grid>
            <Grid
              item
              xs={4}
            >
              <Typography
                variant="caption"
                gutterBottom
              >
                HCPCS Codes
              </Typography>
              <Typography>
                {otherProps['HCPC Codes'].map((item) => {
                  if (item.length === 1) {
                    return item[0]['HCPC S Code'];
                  } else {
                    return `${item[0]['HCPC S Code']} or ${item[1]['HCPC S Code']}`;
                  }
                  
                }).join(', ')}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

InventoryCreateEditTable.propTypes = {
  className: PropTypes.string,
  'Product Name': PropTypes.string,
  Vendor: PropTypes.shape({
    'Vendor Name': PropTypes.string,
  }).isRequired,
  Category: PropTypes.shape({
    Name: PropTypes.string,
  }),
  Condition: PropTypes.shape({
    Name: PropTypes.string,
  }),
  Warehouse: PropTypes.shape({
    Location: PropTypes.string,
  }),
  Model: PropTypes.string,
  Image: PropTypes.arrayOf(PropTypes.shape({
    'File Url': PropTypes.string,
    'File Name': PropTypes.string,
  })).isRequired,
  classes: PropTypes.shape({
    grid: PropTypes.string.isRequired,
  }).isRequired,
};

InventoryCreateEditTable.defaultProps = {
  className: '',
  'Product Name': null,
  'Vendor Name': null,
  Model: null,
  Condition: {},
  Category: {},
  Warehouse: {},
};

export default withStyles(styles)(InventoryCreateEditTable);



// WEBPACK FOOTER //
// ./src/components/inventory/InventoryCreateEditDialog/InventoryCreateEditTable.js